module.exports = __webpack_public_path__ + "static/media/placeholder6.150838b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/placeholder6.jpg
// module id = 628
// module chunks = 0